<form [formGroup]="formName">
  <div class="form-floating mt-4-plus mt-md-5 d-flex">
    <input
      [type]="type"
      [placeholder]="placeholder"
      [attr.required]="required"
      [name]="name"
      [id]="'input-' + htmlId"
      [formControl]="control"
      [ngClass]="{
        'has-tooltip': toolTipMessage,
        'is-invalid': control.invalid && (control.dirty || control.touched),
        'is-valid': (required ? (control.valid && (control.dirty || control.touched) && control.value !== '') : (control.valid && control.value !== '' && (control.dirty || control.touched))),
        'custom-valid': (required ? (control.valid && control.value !== '') : (control.valid && control.value !== '')),
        'ng-invalid': control.invalid
      }"
      class="form-control {{cssClasses}}"
      [autocomplete]="autocomplete"
      [readonly]="readonly"
      (keydown)="onKeyDown($event)"
      (blur)="onBlur()"
    />

    <label [for]="'input-' + htmlId" class="form-label">
      {{ label }}
    </label>

    <ng-container *ngIf="toolTipMessage">
      <div class="align-self-center ps-3">
        <i class="fa-solid fa-circle-question text-primary fs-3" [tooltip]="toolTipMessage"
           container="align-self-center"
           placement="auto"></i>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="(control?.invalid && control?.touched) || error">
    <div class="error-message text-warning ps-2">
      <div *ngIf="errorMessage">
        <span>{{ errorMessage }}</span>
      </div>
      <div *ngIf="!errorMessage && control?.errors?.['required']">
        <span>{{ 'General.ErrorRequired' | translate }}</span>
      </div>
      <div *ngIf="!errorMessage && control?.errors?.['email']">
        <span>{{ 'General.ErrorEmailInvalid' | translate }}</span>
      </div>
      <div *ngIf="!errorMessage && control?.errors?.['emailMismatch']">
        <span>{{ 'General.ErrorEmailNotMatching' | translate }}</span>
      </div>
      <div *ngIf="!errorMessage && control?.errors?.['minlength']">
        <span>{{ 'General.ErrorRequired' | translate }}</span>
      </div>
      <div *ngIf="!errorMessage && control?.errors?.['maxlength']">
        <span>{{ 'General.ErrorRequired' | translate }}</span>
      </div>
      <div *ngIf="!errorMessage && control?.errors?.['pattern']">
        <span>{{ 'General.ErrorRequired' | translate }}</span>
      </div>
    </div>
  </ng-container>
</form>
